module.exports = __webpack_public_path__ + "img/btn_icon01@2x.703c1f57.png";